import useTheme from './useTheme';

export default useTheme;
